import { format } from 'date-fns';
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import iconeEncontreSuaAgencia from '../../../assets/img/icones/personalizados/agencia-cor.svg';
import iconeCadeado from '../../../assets/img/icones/personalizados/cadeado-cor.svg';
import iconeEmail from '../../../assets/img/icones/personalizados/carta-cor.svg';
import iconeCelular from '../../../assets/img/icones/personalizados/celular-cor.svg';
import iconeUsuarioComVisto from '../../../assets/img/icones/personalizados/comercial-visto.svg';
import {
  default as iconeBuscaCep,
  default as iconeMapa,
} from '../../../assets/img/icones/personalizados/mapa-cor.svg';
import iconeMinhasImportacoes from '../../../assets/img/icones/personalizados/mundo-cor.svg';
import iconeOrganograma from '../../../assets/img/icones/personalizados/organograma-usuarios.svg';
import iconeChaves from '../../../assets/img/icones/personalizados/permissoes-cor.svg';
import iconePrecosEPrazos from '../../../assets/img/icones/personalizados/precos-prazos-cor.svg';
import iconeRastreioObjeto from '../../../assets/img/icones/personalizados/rastreamento-cor.svg';
import iconeEscudoComCadeado from '../../../assets/img/icones/personalizados/seguranca-cor.svg';
import iconeCelularComMensagem from '../../../assets/img/icones/personalizados/sms-token-cor.svg';
import iconeUsuarios from '../../../assets/img/icones/personalizados/usuarios-multiplos-cor.svg';
import iconeOuvidoria from '../../../assets/img/icones/personalizados/ouvidoria-cor.svg';
import useAlerta from '../../../components/hooks/useAlerta.js';
import useFetch from '../../../components/hooks/useFetch.js';
import ModalAjuda from '../../../components/modal/ModalAjuda.js';
import ModalDialog from '../../../components/modal/ModalDialog1.js';
import { PERMISSIONARIO_PESQUISAR_ADM } from '../../../services/delegacaoTerceiro.js';
import { ENDERECOS_PESQUISA } from '../../../services/endereco.js';
import { MEUCORREIOS_PESQUISA } from '../../../services/meuCorreios.js';
import { AuthContext } from '../../../store/AuthContext.js';
import FormAjuda from './FormAjudaModal.js';
import FormAlterarEmail from './FormAlterarEmail.js';
import FormAlterarSenha from './FormAlterarSenha.js';
import FormAlterarTelefone from './FormAlterarTelefone.js';
import FormExcluirConta from './FormExcluirConta.js';
import './telaPrincipal.scss';
import { UserContext } from '../../../store/UserContext';

const TelaPrincipalPF = ({ setDados }) => {
  const { t } = useTranslation();
  const origem = window.localStorage.getItem('origem');
  const { request: requestMeuCorreios, data: dadosCPF } = useFetch();
  const { request: requestPerfil, data: dadosPerfil } = useFetch();
  const { request: requestEnderecos, data: dadosEnderecos } = useFetch();
  const [endereco, setEndereco] = useState();
  const [modalAbertoAjuda, setModalAbertoAjuda] = useState(false);
  const [modalAbertoEmail, setModalAbertoEmail] = useState(false);
  const [modalAbertoSenha, setModalAbertoSenha] = useState(false);
  const [modalAbertoTelefone, setModalAbertoTelefone] = useState(false);
  //const [modalAbertoHistoricoToken, setModalAbertoHistoricoToken] =
  //  useState(false);
  const [modalAbertoExcluirConta, setModalAbertoExcluirConta] = useState(false);
  const { abreAlerta } = useAlerta();
  const { user } = useContext(AuthContext);
  const idCorreios = user?.sub;
  const [telefone, setTelefone] = useState();
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(null);
  const [alterei, setAlterei] = useState(false);
  const isInitialRender = useRef(true);
  const { setUsuario } = useContext(UserContext);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    if (dadosCPF) {
      setUsuario(dadosCPF);
      requestEnderecos(ENDERECOS_PESQUISA(idCorreios));
      if (dadosCPF?.usuarioExternoPF?.tipoEstrangeiro === 'N') {
        if (!dadosCPF?.foneMovel) {
          setTelefone('');
        } else {
          setTelefone(
            '(' +
              dadosCPF?.dddMovel +
              ')' +
              dadosCPF?.foneMovel.replace(/(\d{5})(\d{4})/, '$1-$2'),
          );
        }
      } else {
        setTelefone(
          dadosCPF?.ddiMovel +
            ' (' +
            dadosCPF?.dddMovel +
            ')' +
            dadosCPF?.foneMovel,
        );
      }
      setAlterei(false);
      if (dadosCPF?.usuarioExternoPF?.imagem) {
        setImageSrc(
          `data:image/jpeg;base64,${dadosCPF?.usuarioExternoPF?.imagem}`,
        );
      } else {
        setImageSrc('/images/avatar-placeholder.svg');
      }
    }
  }, [dadosCPF]);

  useEffect(() => {
    var enderecoBanco = '';
    dadosEnderecos?.forEach((endereco) => {
      if (endereco.principal == 'S') {
        enderecoBanco = endereco.logradouro;
        if (endereco.numero) {
          enderecoBanco += ', ' + endereco.numero;
        }
        if (endereco.complemento) {
          enderecoBanco += ', ' + endereco.complemento;
        }
        if (endereco.bairro) {
          enderecoBanco += ', ' + endereco.bairro;
        }
        enderecoBanco +=
          ', ' +
          endereco.cidade +
          ', ' +
          endereco.uf +
          ', ' +
          endereco.nomePais;

        setEndereco(enderecoBanco);
      }
    });
  }, [dadosEnderecos]);

  const fechar = () => {
    setModalAbertoTelefone(false);
    setModalAbertoEmail(false);
    //setModalAbertoDadosBrasileiro(false);
    setAlterei(true);
  };
  useEffect(() => {
    if (idCorreios && idCorreios != '') {
      requestMeuCorreios(MEUCORREIOS_PESQUISA(idCorreios));
      requestPerfil(PERMISSIONARIO_PESQUISAR_ADM(idCorreios));
    } else navigate('/login');
  }, [alterei]);

  const chamaEndereco = () => {
    navigate('/endereco', { state: dadosEnderecos });
  };
  const chamaDependentes = () => {
    navigate('/dependentes', { state: dadosCPF });
  };
  const chamaHistoricoToken = () => {
    navigate('/historicoToken', { state: dadosCPF });
  };
  const chamaPermissoesRecebidasSistemas = () => {
    navigate('/permissoesRecebidasSistemas', { state: dadosCPF });
  };
  const chamaPermissoesRecebidasContratos = () => {
    navigate('/permissoesRecebidasContratos', { state: dadosCPF });
  };
  const chamaAlterarDados = () => {
    if (dadosCPF?.usuarioExternoPF?.cie)
      navigate('/dadosEstrangeiro', { state: dadosCPF });
    else {
      navigate('/dadosBrasileiro', { state: dadosCPF });
    }
  };
  const chamaTereceiroDelegar = () => {
    navigate('/permitirDelegar', { state: dadosCPF });
  };
  const chamaDelegacaoAcesso = () => {
    navigate('/delegacaoAcesso', { state: { dados: dadosCPF, dadosPerfil } });
  };

  const abrirModalTelefone = () => {
    if (dadosCPF) {
      setModalAbertoTelefone(true);
    }
  };
  return (
    <>
      <div className="conteudoTP">
        {origem && origem == 'meuCorreios' && (
          <>
            <div className="titulo-bem-vindoTP">
              <h1 className="msg-bemvindoTP">{t('telaPrincipal.welcome')}</h1>
              <button
                type="button"
                id="btn-ajuda"
                className="btn-txt"
                onClick={() => setModalAbertoAjuda(true)}
              >
                <i className="ic-duvida"></i>
                {t('telaPrincipal.help')}
              </button>
            </div>

            <a
              target="_blank"
              href="https://www.correios.com.br/atendimento/ferramentas/aplicativo-dos-correios/aplicativo-dos-correios"
              className="banner-contrate"
            >
              <picture>
                <source
                  srcSet="/images/banner-pf-app-correios-mobile.png"
                  media="(max-width: 599px)"
                  type="image/png"
                />

                <img
                  src="/images/banner-pf-app-correios.png"
                  alt={t('telaPrincipal.contractCorreios')}
                />
              </picture>
            </a>
          </>
        )}
        <div id="perfil" className="card bg-superficie elev1">
          <div id="dados">
            <img id="img-perfil" alt="Imagem de perfil" src={imageSrc} />

            <div>
              <div id="nomeUsuario" className="t2">
                <span>{dadosCPF?.nome}</span>{' '}
                {dadosPerfil?.perfil && (
                  <>
                    <span className="mini">({dadosPerfil?.perfil})</span>
                  </>
                )}
              </div>

              <div className="titulo-texto">
                <h6>{t('telaPrincipal.user')}:</h6>
                <div>{dadosCPF?.idCorreios}</div>
              </div>
              <div className="titulo-texto">
                <h6>{t('telaPrincipal.gender')}:</h6>
                <div>
                  {dadosCPF?.usuarioExternoPF?.sexo === 'M'
                    ? t('telaPrincipal.genderMale')
                    : dadosCPF?.usuarioExternoPF?.sexo === 'F'
                    ? t('telaPrincipal.genderFemale')
                    : dadosCPF?.usuarioExternoPF?.sexo === 'O'
                    ? t('telaPrincipal.genderOther')
                    : t('telaPrincipal.genderNotInform')}
                </div>
              </div>
              <div className="titulo-texto">
                <h6>{t('telaPrincipal.birthDate')}:</h6>
                <div>
                  {dadosCPF?.usuarioExternoPF?.dataNascimento
                    ? format(
                        new Date(
                          dadosCPF?.usuarioExternoPF?.dataNascimento +
                            'T00:00:00',
                        ),
                        'dd-MM-yyyy',
                      )
                    : ''}
                </div>
              </div>
              {dadosCPF?.usuarioExternoPF?.cpf && (
                <div className="titulo-texto">
                  <h6>{t('telaPrincipal.cpf')}:</h6>
                  <div>
                    {dadosCPF?.usuarioExternoPF?.cpf?.replace(
                      /(\d{3})(\d{3})(\d{3})(\d{2})/,
                      '$1.$2.$3-$4',
                    )}
                  </div>
                </div>
              )}
              {dadosCPF?.usuarioExternoPF?.cie && (
                <div className="titulo-texto">
                  <h6>{t('telaPrincipal.passportId')}:</h6>
                  <div>{dadosCPF?.usuarioExternoPF?.cie}</div>
                </div>
              )}
              {!dadosCPF?.usuarioExternoPF?.responsavel && (
                <button
                  id="btn-abrir-dados"
                  className="btn-txt"
                  onClick={() => chamaAlterarDados()}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editData')}
                </button>
              )}
            </div>
          </div>

          <hr />

          <div id="dados-separados">
            <div className="dado-separado-container">
              <div>
                <img
                  className="img-card"
                  alt="ícone de e-mail"
                  src={iconeEmail}
                />
                <div>
                  <h6>{t('telaPrincipal.email')}:</h6>
                  {dadosCPF?.email}
                </div>
              </div>
              {!dadosCPF?.usuarioExternoPF?.responsavel && (
                <button
                  id="btn-abrir-email"
                  className="btn-txt"
                  onClick={() => setModalAbertoEmail(true)}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editEmail')}
                </button>
              )}
            </div>

            <div className="dado-separado-container">
              <div>
                <img
                  className="img-card"
                  alt="ícone de telefone"
                  src={iconeCelular}
                />
                <div>
                  <h6>{t('telaPrincipal.phone')}:</h6>
                  {telefone}
                </div>
              </div>
              {!dadosCPF?.usuarioExternoPF?.responsavel && (
                <button
                  id="btn-abrir-tel"
                  className="btn-txt"
                  onClick={abrirModalTelefone}
                  //onClick={() => setModalAbertoTelefone(true)}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editPhone')}
                </button>
              )}
            </div>
            {!dadosCPF?.usuarioExternoPF?.responsavel && (
              <div className="dado-separado-container">
                <div>
                  <img
                    className="img-card"
                    alt="ícone de cadeado"
                    src={iconeCadeado}
                  />
                  <div>
                    <h6>{t('telaPrincipal.password')}:</h6>
                    {t('telaPrincipal.passwordMessage')}
                  </div>
                </div>
                <button
                  id="btn-abrir-senha"
                  className="btn-txt"
                  onClick={() => setModalAbertoSenha(true)}
                >
                  <i className="ic-editar"></i>
                  {t('telaPrincipal.editPassword')}
                </button>
              </div>
            )}
          </div>
        </div>
        {!dadosCPF?.usuarioExternoPF?.responsavel && (
          <>
            <div id="endereco" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de mapa com pin"
                  src={iconeMapa}
                />
                <h3>{t('principal.addresses.title')}</h3>
              </div>

              <div className="card-descricao">
                <b>{t('telaPrincipal.mainAddress')}:</b>
                <br />
                {endereco}
              </div>

              <button className="btn-txt" onClick={() => chamaEndereco()}>
                <i className="ic-busca-cep"></i>
                {t('telaPrincipal.manageAddresses')}
              </button>
            </div>

            <div id="token" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de celular com mensagem de texto"
                  src={iconeCelularComMensagem}
                />
                <h3>{t('principal.help.token_history.title')}</h3>
              </div>

              <div className="card-descricao">
                {t('telaPrincipal.tokenHistoryDescription')}
              </div>

              <button className="btn-txt" onClick={() => chamaHistoricoToken()}>
                <i className="ic-celular"></i>
                {t('telaPrincipal.consult')}
              </button>
            </div>
            <div id="dependentes" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de multiplos usuarios"
                  src={iconeUsuarios}
                />
                <h3>{t('principal.help.dependents.title')}</h3>
              </div>

              <div className="card-descricao">
                {t('telaPrincipal.dependentsDescription')}
              </div>

              <button className="btn-txt" onClick={() => chamaDependentes()}>
                <i className="ic-atendimento"></i>
                {t('telaPrincipal.manageDependents')}
              </button>
            </div>
            <div id="permissoes" className="card bg-superficie elev1">
              <div>
                <img
                  className="img-card"
                  alt="ícone de chaves"
                  src={iconeChaves}
                />
                <h3>{t('principal.received_permissions.title')}</h3>
              </div>

              <div className="card-descricao">
                {t('telaPrincipal.receivedPermissionsDescription')}
              </div>

              <div>
                <button
                  className="btn-txt"
                  onClick={() => chamaPermissoesRecebidasContratos()}
                >
                  <i className="ic-contrato"></i>
                  {t('telaPrincipal.contracts')}
                </button>
                <button
                  className="btn-txt"
                  onClick={() => chamaPermissoesRecebidasSistemas()}
                >
                  <i className="ic-tv"></i>
                  {t('telaPrincipal.systems')}
                </button>
              </div>
            </div>

            {dadosPerfil && (
              <div id="delegacao" className="card bg-superficie elev1">
                <div>
                  <img
                    className="img-card"
                    alt="ícone de usuário com um visto"
                    src={iconeUsuarioComVisto}
                  />
                  <h3>{t('telaPrincipal.accessDelegation')}</h3>
                </div>

                <div className="card-descricao">
                  {t('telaPrincipal.accessDelegationDescription')}
                </div>

                <button
                  className="btn-txt"
                  onClick={() => chamaDelegacaoAcesso()}
                >
                  <i className="ic-usuario-visto"></i>
                  {t('telaPrincipal.delegateAccess')}
                </button>
              </div>
            )}
            {dadosPerfil && dadosPerfil.perfil == 'Administrador' && (
              <div
                id="delegacao-terceiros"
                className="card bg-superficie elev1"
              >
                <div>
                  <img
                    className="img-card"
                    alt="ícone de um organograma"
                    src={iconeOrganograma}
                  />
                  <h3>{t('telaPrincipal.allowThirdPartyDelegation')}</h3>
                </div>

                <div className="card-descricao">
                  {t('telaPrincipal.allowThirdPartyDelegationDescription')}
                </div>

                <button
                  className="btn-txt"
                  onClick={() => chamaTereceiroDelegar()}
                >
                  <i className="ic-usuario-adicionar"></i>
                  {t('telaPrincipal.addThirdParty')}
                </button>
              </div>
            )}
          </>
        )}
        <div id="privacidade" className="card bg-superficie elev1">
          <div>
            <img
              className="img-card"
              alt="ícone de escudo com cadeado"
              src={iconeEscudoComCadeado}
            />
            <h3>{t('telaPrincipal.privacyPolicy')}</h3>
          </div>

          <div className="card-descricao">
            {t('telaPrincipal.accessThe')}&ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-cookies"
              target="_blank"
            >
              {t('telaPrincipal.privacyPolicyLink')}
            </a>
            {!dadosCPF?.usuarioExternoPF?.responsavel && (
              <>&nbsp; {t('telaPrincipal.privacyPolicyMessage')}</>
            )}
          </div>
        </div>

        {/* BANNER DE PESQUISA DESATIVADO
        
        <a
          target="_blank"
          href="https://c.correios.com.br/meu-correios"
          className="banner-contrate"
        >
          <picture>
            <source
              srcSet="/images/Banner-pesquisa-mob.png"
              media="(max-width: 599px)"
              type="image/png"
            />

            <img
              src="/images/Banner-pesquisa.png"
              alt={t('telaPrincipal.contractCorreios')}
            />
          </picture>
        </a> */}

        {!dadosCPF?.usuarioExternoPF?.responsavel && (
          <div id="excluir-conta">
            <h6>{t('telaPrincipal.deactivateAccount')}</h6>
            <p>
              {t('telaPrincipal.deactivateAccountMessage')}&ensp;
              <a
                id="abrir-excluir-conta"
                className="txt-link"
                onClick={() => setModalAbertoExcluirConta(true)}
              >
                {t('telaPrincipal.deactivateAccountConfirm')}
              </a>
            </p>
          </div>
        )}
      </div>
      {origem && origem == 'meuCorreios' && (
        <div id="acesso-rapido" className="bg-azul-correios">
          <div className="acesso-rapido-container">
            <h2>{t('telaPrincipal.quickAccess')}</h2>
            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://rastreamento.correios.com.br/app/index.php"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de rastreio de objetos"
                  src={iconeRastreioObjeto}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.trackYourObject')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://www2.correios.com.br/sistemas/precosPrazos/"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de preços e prazos"
                  src={iconePrecosEPrazos}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.pricesAndDeadlines')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone do busca cep ou endereço"
                  src={iconeBuscaCep}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.searchZipAddress')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://cas.correios.com.br/login?service=https%3A%2F%2Fapps.correios.com.br%2Fportalimportador%2Fpages%2FpesquisarRemessaImportador%2FpesquisarRemessaImportador.jsf"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de minhas importações"
                  src={iconeMinhasImportacoes}
                />
                <p className="subtitulo-p">{t('telaPrincipal.myImports')}</p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://buscaagencia.correios.com.br/"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de encontre sua agência"
                  src={iconeEncontreSuaAgencia}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.findYourAgency')}
                </p>
              </a>
            </div>

            <div className="card card-clicavel bg-superficie elev5">
              <a
                href="https://c.correios.com.br/meu-correios"
                target="_blank"
                rel="noopener"
                className="txt-link"
              >
                <img
                  className="acesso-rapido-img"
                  alt="ícone de balão de conversa"
                  src={iconeOuvidoria}
                />
                <p className="subtitulo-p">
                  {t('telaPrincipal.rateSignUpExperience')}
                </p>
              </a>
            </div>
          </div>
        </div>
      )}
      <ModalAjuda
        aberto={modalAbertoAjuda}
        setAberto={setModalAbertoAjuda}
        opcaoFechar={true}
      >
        <FormAjuda acaoCancelar={() => setModalAbertoAjuda(false)} />
      </ModalAjuda>
      <ModalDialog
        titulo={t('telaPrincipal.editEmail')}
        id="moda-email"
        aberto={modalAbertoEmail}
        setAberto={setModalAbertoEmail}
        opcaoFechar={true}
      >
        <FormAlterarEmail
          acaoCancelar={() => setModalAbertoEmail(false)}
          acaoFechar={fechar}
          dados={dadosCPF}
        />
      </ModalDialog>
      <ModalDialog
        titulo={t('telaPrincipal.editPassword')}
        id="modal-senha"
        aberto={modalAbertoSenha}
        setAberto={setModalAbertoSenha}
        opcaoFechar={true}
      >
        <FormAlterarSenha
          acaoCancelar={() => setModalAbertoSenha(false)}
          acaoFechar={fechar}
          dados={dadosCPF}
        />
      </ModalDialog>
      <ModalDialog
        titulo={t('telaPrincipal.editPhone')}
        id="modal-teledone"
        aberto={modalAbertoTelefone}
        setAberto={setModalAbertoTelefone}
        opcaoFechar={true}
      >
        <FormAlterarTelefone
          acaoCancelar={() => setModalAbertoTelefone(false)}
          acaoFechar={fechar}
          dados={dadosCPF}
        />
      </ModalDialog>
      {/* <ModalDialog
        titulo="Histórico de tokens"
        id="modal-historico-tokens"
        aberto={modalAbertoHistoricoToken}
        setAberto={setModalAbertoHistoricoToken}
        opcaoFechar={true}
      >
        <FormHistoricoToken
          acaoCancelar={() => setModalAbertoHistoricoToken(false)}
          dados={dadosCPF}
        />
      </ModalDialog>*/}
      <ModalDialog
        titulo={t('telaPrincipal.deactivateAccount')}
        id="modal-excluir-conta"
        aberto={modalAbertoExcluirConta}
        setAberto={setModalAbertoExcluirConta}
        opcaoFechar={true}
      >
        <FormExcluirConta
          acaoCancelar={() => setModalAbertoExcluirConta(false)}
          dados={dadosCPF}
          tipoPessoa="1"
        />
      </ModalDialog>
    </>
  );
};

export default TelaPrincipalPF;
